import React from 'react';
import { useTranslation } from 'react-i18next';

export const RequestsStats = ({
  statusCounts,
  statusFilter,
  onStatusFilterChange,
}) => {
  const { t } = useTranslation();

  const getStatusFilterStyle = (status, isSelected) => {
    const statusStyles = {
      all: {
        bg: isSelected ? 'bg-slate-100' : 'bg-white',
        border: isSelected ? 'border-slate-400' : 'border-slate-200',
        text: isSelected ? 'text-slate-800' : 'text-slate-600',
        hover: 'hover:border-slate-300'
      },
      pending: {
        bg: isSelected ? 'bg-yellow-100' : 'bg-yellow-50',
        border: isSelected ? 'border-yellow-400' : 'border-yellow-200',
        text: isSelected ? 'text-yellow-800' : 'text-yellow-700',
        hover: 'hover:border-yellow-300'
      },
      confirmed: {
        bg: isSelected ? 'bg-blue-100' : 'bg-blue-50',
        border: isSelected ? 'border-blue-400' : 'border-blue-200',
        text: isSelected ? 'text-blue-800' : 'text-blue-700',
        hover: 'hover:border-blue-300'
      },
      deposit: {
        bg: isSelected ? 'bg-purple-100' : 'bg-purple-50',
        border: isSelected ? 'border-purple-400' : 'border-purple-200',
        text: isSelected ? 'text-purple-800' : 'text-purple-700',
        hover: 'hover:border-purple-300'
      },
      settled: {
        bg: isSelected ? 'bg-green-100' : 'bg-green-50',
        border: isSelected ? 'border-green-400' : 'border-green-200',
        text: isSelected ? 'text-green-800' : 'text-green-700',
        hover: 'hover:border-green-300'
      },
      cancelled: {
        bg: isSelected ? 'bg-orange-100' : 'bg-orange-50',
        border: isSelected ? 'border-orange-400' : 'border-orange-200',
        text: isSelected ? 'text-orange-800' : 'text-orange-700',
        hover: 'hover:border-orange-300'
      },
      rejected: {
        bg: isSelected ? 'bg-red-100' : 'bg-red-50',
        border: isSelected ? 'border-red-400' : 'border-red-200',
        text: isSelected ? 'text-red-800' : 'text-red-700',
        hover: 'hover:border-red-300'
      },
      awaiting: {
        bg: isSelected ? 'bg-orange-100' : 'bg-orange-50',
        border: isSelected ? 'border-orange-400' : 'border-orange-200',
        text: isSelected ? 'text-orange-800' : 'text-orange-700',
        hover: 'hover:border-orange-300'
      },
    };

    const style = statusStyles[status] || statusStyles.all;
    return `${style.bg} ${style.border} ${style.text} ${style.hover} ${isSelected ? 'shadow-md' : ''}`;
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case 'all':
        return t("all");
      case 'pending':
        return t("pending");
      case 'confirmed':
        return t("confirmed");
      case 'deposit':
        return t("deposit");
      case 'settled':
        return t("settled");
      case 'cancelled':
        return t("cancelled");
      case 'rejected':
        return t("rejected");
      case 'awaiting':
        return t("awaiting") + ' ' + t("discount");
      default:
        return status;
    }
  };

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-8 gap-4 mb-6">
      {Object.entries(statusCounts || {})?.map(([status, count]) => {
        return (
          <button
            key={status}
            onClick={() => onStatusFilterChange(status)}
            className={`p-4 rounded-xl border-2 transition-all duration-200 text-center ${statusFilter === status
              ? getStatusFilterStyle(status, true)
              : getStatusFilterStyle(status, false)
              }`}
          >
            <div>
              <div className="text-2xl font-bold mb-1">{count}</div>
              <div className="text-xs font-medium">{getStatusLabel(status)}</div>
            </div>
          </button>
        )
      })}
    </div>
  );
};

export default RequestsStats;